import { render, staticRenderFns } from "./ImportTables.vue?vue&type=template&id=55d227a3&scoped=true&"
import script from "./ImportTables.vue?vue&type=script&lang=js&"
export * from "./ImportTables.vue?vue&type=script&lang=js&"
import style0 from "./ImportTables.vue?vue&type=style&index=0&id=55d227a3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d227a3",
  null
  
)

export default component.exports